import { Injectable } from '@angular/core';
// DKM-5193 Cedric: eski hâli
// import {BehaviorSubject, catchError, finalize, Observable, tap, throwError} from "rxjs";
import {BehaviorSubject, catchError, finalize, firstValueFrom, Observable, tap, throwError} from "rxjs";
import {
  DataCoreService,
  DlistDto,
  DlistFieldDto, environment as env,
  FormDto,
  GetDlist_Request,
  GetDlist_Response
} from "@dabnet-kamu/libs/ui";
import {HttpClient} from "@angular/common/http";
// DKM-1078 Cedric: eski hâli — libs/ui, libs/ys'e göreli yolla bağımlıydı (katman ihlali, model de eski CodeGen)
// import {HlpBasvuru} from "../../../../../../ys/src/lib/components/gen-help-desk/models/hel-desk-auto.model";

/** DKM-1078 Cedric: "Destek Talebi Aç" formunun kullandığı HLP_BASVURU alanları (entity: HlpBasvuru). */
export interface HlpBasvuru {
  Kod?: number;
  BelediyeKod?: number;
  KategoriKod?: number;
  Baslik?: string;
  Detay?: string;
  HtmlEh?: string;
  BasvuruKullaniciKod?: number;
  AtananKullaniciKod?: number;
  BasvuruDurum?: number;
  Oncelik?: number;
  FormKod?: number;
  FormAd?: string;
  SubFormAd?: string;
  KayitKod?: number;
  EmailEh?: string;
  SmsEh?: string;
  BirimKod?: number;
  Seviye?: number;
  [alan: string]: any;
}

/** DKM-5193 Cedric: Hlp_HlpBasvuruDosyaKaydet_Request (RR_HlpBasvuruDosya.cs) */
export interface HlpBasvuruDosyaKaydetIstek {
  basvuruKod: number;
  /** EKRAN | HATA */
  tur: 'EKRAN' | 'HATA';
  /** base64 ya da data URL */
  icerikBase64: string;
  /** Yalnız HATA: dahili nota yazılacak kısa özet */
  ozet?: string;
}

export interface HlpBasvuruDosyaKaydetYanit {
  result?: boolean;
  errorMessage?: string;
  dosyaKod?: number;
  dosyaAd?: string;
  boyut?: number;
}

@Injectable({
  providedIn: 'root'
})
export class DkListHelpFormService {
  errorResponse: string[]
  formMetadata$: Observable<FormDto | null>;


  private _gridControlsHlpBasvuru: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
  public gridControlsHlpBasvuru$ = this._gridControlsHlpBasvuru.asObservable();




  constructor(private dataCoreService: DataCoreService, private httpClient: HttpClient) {
  }

  getHelpDeskData() {
    const dataSource = this.dataCoreService.getOData('HlpBasvuru');
    dataSource.select();
    return dataSource;
  }


  insertHlpBasvuru(data: HlpBasvuru): Promise<any> {
    return this.dataCoreService.createDataStore('HlpBasvuru', data);
  }

  updateHlpBasvuru(data: HlpBasvuru): Promise<any> {
    return this.dataCoreService.updateDataStore('HlpBasvuru', data);
  }

  removeHlpBasvuru(data: HlpBasvuru): Promise<any> {
    return this.dataCoreService.removeDataStore('HlpBasvuru', data);
  }

  /**
   * DKM-5193 Cedric: talebe ek (ekran görüntüsü / hata listesi) — Genservices POST HLP/Hlp/HlpBasvuruDosyaKaydet.
   * Dosya sunucu diskinde tutulur; yalnız talebi açan kullanıcı, talep açıldıktan sonraki 15 dk içinde ekleyebilir.
   */
  dosyaKaydet(req: HlpBasvuruDosyaKaydetIstek): Promise<HlpBasvuruDosyaKaydetYanit> {
    const taban = (env.genService ?? '').replace(/\/+$/, '');
    return firstValueFrom(this.httpClient.post<HlpBasvuruDosyaKaydetYanit>(`${taban}/HLP/Hlp/HlpBasvuruDosyaKaydet`, req));
  }


  getDlist(formName: string): any {
    const request = new GetDlist_Request({
      dListCode: formName
    })
    this.httpClient.post<GetDlist_Response>(`${env.lookupService}/System/GetDList`, request).pipe(
      tap(response => {
        if (formName === 'HlpBasvuru') {
          this._gridControlsHlpBasvuru.next(response.dListMetadata)
        }


      }),
      catchError(err => throwError(err)),
      finalize(() => {
      })
    ).subscribe();
  }
}
